import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=4235a208&scoped=true&"
import script from "./Activate.vue?vue&type=script&lang=js&"
export * from "./Activate.vue?vue&type=script&lang=js&"
import style0 from "./Activate.vue?vue&type=style&index=0&id=4235a208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4235a208",
  null
  
)

export default component.exports